import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteDemandProcurementMaster,
  listDemandProcurementMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要調達計画マスタ 削除 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listDemandProcurementMasters を invalidate してテーブルを最新化する。
 */
export function useDeleteDemandProcurementMaster(): InvalidatingMutationResultFor<
  typeof deleteDemandProcurementMaster
> {
  return useInvalidatingMutation(deleteDemandProcurementMaster, [
    createConnectQueryKey({
      schema: listDemandProcurementMasters,
      cardinality: 'finite',
    }),
  ])
}
